import ClinicalTrialsBlock from './ClinicalTrialsBlock';

globalThis.ClinicalTrialsComponents = {
  ClinicalTrialsBlock,
};
